import DelayedRenderer from "./DelayedRender";
export default DelayedRenderer;
